import CategoryIcon from "@mui/icons-material/Category";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FactoryIcon from "@mui/icons-material/Factory";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import LockPersonOutlinedIcon from "@mui/icons-material/LockPersonOutlined";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleIcon from "@mui/icons-material/People";
import ScaleIcon from "@mui/icons-material/Scale";
import StarBorderPurple500Icon from "@mui/icons-material/StarBorderPurple500";
import StarIcon from "@mui/icons-material/Star";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PentagonIcon from "@mui/icons-material/Pentagon";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import {
  BARCODE,
  BARCODE_EDIT,
  CHARACTER_MASTER,
  CHARACTER_MASTER_ADD,
  CHARACTER_MASTER_EDIT,
  CHROMA_COLLECTION,
  CHROMA_COLLECTION_EDIT,
  COLOUR_MASTER,
  COLOUR_MASTER_ADD,
  COLOUR_MASTER_EDIT,
  DISPATCH_ADDRESS_MASTER,
  DISPATCH_ADDRESS_MASTER_ADD,
  DISPATCH_ADDRESS_MASTER_EDIT,
  PATTERN_MASTER,
  PATTERN_MASTER_ADD,
  PATTERN_MASTER_EDIT,
  PHOTO_MASTER,
  PHOTO_MASTER_ADD,
  PHOTO_MASTER_EDIT,
  PROCESS_MASTER,
  PROCESS_MASTER_ADD,
  PROCESS_MASTER_EDIT,
  TRANSPORTER_MASTER,
  TRANSPORTER_MASTER_ADD,
  TRANSPORTER_MASTER_EDIT,
  VEHICLE_MASTER,
  VEHICLE_MASTER_ADD,
  VEHICLE_MASTER_EDIT,
  CUSTOMER_MASTER,
  CUSTOMER_MASTER_ADD,
  CUSTOMER_MASTER_EDIT,
  CUSTOMER_MASTER_VIEW,
  FURROW,
  FURROW_EDIT,
  FURROW_ADD,
  CHROMA_COLLECTION_ADD,
  BARCODE_ADD,
  CHROMA_COMPOSITE,
  CHROMA_COMPOSITE_ADD,
  CHROMA_COMPOSITE_EDIT,
  CHROMA_RIBBED,
  CHROMA_RIBBED_ADD,
  CHROMA_RIBBED_EDIT,
  BUNITO,
  BUNITO_ADD,
  BUNITO_EDIT,
  MATTLE,
  MATTLE_ADD,
  MATTLE_EDIT,
  CANVAS,
  CANVAS_ADD,
  CANVAS_EDIT,
  NOVEL,
  NOVEL_ADD,
  NOVEL_EDIT,
  MARVEL,
  MARVEL_ADD,
  MARVEL_EDIT,
  REGANTO_DEZINER,
  REGANTO_DEZINER_ADD,
  REGANTO_DEZINER_EDIT,
  REGANTO_CLASSIC,
  REGANTO_CLASSIC_ADD,
  REGANTO_CLASSIC_EDIT,
  REGANTO_PREMIER,
  REGANTO_PREMIER_ADD,
  REGANTO_PREMIER_EDIT,
  ACCO,
  ACCO_ADD,
  ACCO_EDIT,
  FURROW_LITE,
  FURROW_LITE_EDIT,
  FURROW_LITE_ADD,
  FURROW_REGANTO,
  FURROW_REGANTO_ADD,
  FURROW_REGANTO_EDIT,
  PEELING_FACTORY,
  PEELING_FACTORY_ADD,
  PEELING_FACTORY_EDIT,
  FACTORY_SLICING,
  FACTORY_SLICING_ADD,
  FACTORY_SLICING_EDIT,
  FACTORY_GROUPING,
  FACTORY_RE_SLICING_ADD,
  FACTORY_DRESSING,
  FACTORY_RE_DRESSING_ADD,
  FACTORY_DRESSING_ADD,
  FACTORY_DRESSING_EDIT,
  FACTORY_SMOKING_DYING,
  FACTORY_GROUPING_EDIT,
  FACTORY_GROUPING_ADD,
  FACTORY_SMOKING_DYING_ADD,
  FACTORY_SMOKING_DYING_EDIT,
  FACTORY_REGROUPING_ADD,
  ORDER_ROUTE,
  CREATE_RAW_ORDER,
  CREATE_DECORATIVE_ORDER,
  EDIT_DECORATIVE_ORDER,
  PHOTO_MASTER_VIEW_DETAILS,
  POLISH_MASTER,
  POLISH_MASTER_ADD,
  POLISH_MASTER_EDIT,
  POLISH_MASTER_VIEW_DETAILS,
  FACTORY_TAPPING,
  FACTORY_PRESSING,
  FACTORY_CNC,
  FACTORY_CNC_ADD,
  FACTORY_COLOUR,
  FACTORY_BUNITO,
  FACTORY_CANVAS,
  FACTORY_POLISHING,
  FACTORY_ACCO,
  FACTORY_PLYWOOD_PRODUCTION,
  FACTORY_RE_SIZING_PLYWOOD,
  PACKING_ROUTE,
  DISPATCH_ROUTE,
  CHALLAN_ROUTE,
  PLYWOOD_RAW_ORDER,
  MDF_RAW_ORDER,
  LOG_INVENTORY_ISSUE_ORDER,
  FLITCH_INVENTORY_ISSUE_ORDER,
  VENEER_INVENTORY_ISSUE_ORDER,
  FACE_RAW_ORDER,
  CORE_RAW_ORDER,
  FLEECE_RAW_ORDER,
  OTHER_GOODS_RAW_ORDER,
  DRESSING_FACTORY_ISSUE_ORDER,
  FACTORY_TAPPING_ADD,
  FACTORY_TAPPING_EDIT,
  FACTORY_RE_SIZING_PLYWOOD_ADD,
  FACTORY_CREATE_PLYWOOD_PRODUCTION,
  FACTORY_EDIT_PLYWOOD_PRODUCTION,
  CROSSCUT_FACTORY_ISSUE_ORDER,
  FACTORY_RE_SIZING_PLYWOOD_EDIT,
  FLITCHING_FACTORY_ISSUE_ORDER,
  GROUPING_FACTORY_ISSUE_ORDER,
  FACTORY_PRESSING_ADD,
  FACTORY_BUNITO_ADD,
  FACTORY_COLOUR_ADD,
  FACTORY_POLISHING_ADD,
  FACTORY_CANVAS_ADD,
  CHALLAN_ADD_ROUTE,
  CHALLAN_VIEW_ROUTE,
  CHALLAN_EDIT_ROUTE,
  PACKING_VIEW_ROUTE,
  PACKING_ADD_ROUTE_RAW,
  PACKING_ADD_ROUTE_FINISHED,
  PACKING_EDIT_RAW_ROUTE,
  PACKING_EDIT_FINISHED_ROUTE,
  DISPATCH_ADD_ROUTE,
  DISPATCH_APPROVAL_ROUTE,
  DISPATCH_EDIT_ROUTE,
  DISPATCH_VIEW_ROUTE,
  PACKING_APPROVAL_VIEW_DETAILS_ROUTE,
  DISPATCH_APPROVAL_VIEW_ROUTE,
} from "app/utils/constants/routeConstant";
import { MoveToInbox } from "@mui/icons-material";

const menus = [
  {
    uri: "/dashboard",
    label: "sidebar.menuItem.dashboard",
    type: "nav-item",
    icon: <DashboardIcon sx={{ fontSize: 20 }} />,
  },
  {
    uri: "/user",
    isActiveUri: ["/user/add", "/user/edit", "/user/change-password"],
    label: "sidebar.menuItem.userManagement",
    type: "nav-item",
    permission: "user",
    icon: <PeopleIcon sx={{ fontSize: 20 }} />,
  },
  {
    uri: "/roles",
    isActiveUri: ["/roles/edit", "/roles/add"],
    label: "sidebar.menuItem.roleAndPermission",
    type: "nav-item",
    permission: "role",
    icon: <LockPersonOutlinedIcon sx={{ fontSize: 20 }} />,
  },
  {
    uri: "/master/approval-config",
    isActiveUri: [],
    label: "Approval Config",
    type: "nav-item",
    permission: "approval_config",
    icon: <LockPersonOutlinedIcon sx={{ fontSize: 20 }} />,
  },
  {
    label: "sidebar.menu.master",
    type: "collapsible",
    icon: <StarBorderPurple500Icon sx={{ fontSize: 20 }} />,
    children: [
      {
        uri: CHARACTER_MASTER,
        label: "Character",
        isActiveUri: [CHARACTER_MASTER_ADD, CHARACTER_MASTER_EDIT],
        permission: "character_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: COLOUR_MASTER,
        label: "Color",
        isActiveUri: [COLOUR_MASTER_ADD, COLOUR_MASTER_EDIT],
        permission: "colour_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/cut",
        label: "Cut",
        isActiveUri: ["/master/cut/add", "/master/cut/edit"],
        permission: "cut_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/currency",
        label: "Currency",
        isActiveUri: ["/master/currency/add", "/master/currency/edit"],
        permission: "currency_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: CUSTOMER_MASTER,
        label: "Customer",
        isActiveUri: [
          CUSTOMER_MASTER_ADD,
          CUSTOMER_MASTER_EDIT,
          CUSTOMER_MASTER_VIEW,
        ],
        permission: "customer_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/department",
        label: "Department",
        isActiveUri: ["/master/department/add", "/master/department/edit"],
        permission: "department_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: DISPATCH_ADDRESS_MASTER,
        label: "Dispatch Address",
        isActiveUri: [
          DISPATCH_ADDRESS_MASTER_ADD,
          DISPATCH_ADDRESS_MASTER_EDIT,
        ],
        permission: "dispatch_address_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/expenseType",
        label: "Expense Type",
        isActiveUri: ["/master/expenseType/add", "/master/expenseType/edit"],
        permission: "expense_type_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/grade",
        label: "sidebar.menuItem.master.grade",
        isActiveUri: ["/master/grade/add", "/master/grade/edit"],
        permission: "grade_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },

      {
        uri: "/master/gst",
        label: "GST",
        isActiveUri: ["/master/gst/add", "/master/gst/edit"],
        permission: "gst_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/item-category/list",
        label: "Item Category",
        isActiveUri: [
          "/master/item-category/add",
          "/master/item-category/edit/:id",
        ],
        permission: "item_category_master",
        type: "nav-item",
        icon: <ScaleIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/item-name",
        label: "sidebar.menuItem.master.itemName",
        isActiveUri: ["/master/item-name/add", "/master/item-name/edit"],
        permission: "item_name_master",
        type: "nav-item",
        icon: <DescriptionOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/item-subcategory/list",
        label: "Item Sub-Category",
        isActiveUri: [
          "/master/item-subcategory/add",
          "/master/item-subcategory/edit",
        ],
        permission: "item_sub_category_master",
        type: "nav-item",
        icon: <ScaleIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/machine",
        label: "Machine",
        isActiveUri: ["/master/machine/add", "/master/machine/edit"],
        permission: "machine_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: PATTERN_MASTER,
        label: "Pattern",
        isActiveUri: [PATTERN_MASTER_ADD, PATTERN_MASTER_EDIT],
        permission: "pattern_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: PHOTO_MASTER,
        label: "Photo",
        isActiveUri: [
          PHOTO_MASTER_ADD,
          PHOTO_MASTER_EDIT,
          PHOTO_MASTER_VIEW_DETAILS,
        ],
        permission: "photo_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: POLISH_MASTER,
        label: "Polish",
        isActiveUri: [
          POLISH_MASTER_ADD,
          POLISH_MASTER_EDIT,
          POLISH_MASTER_VIEW_DETAILS,
        ],
        permission: "polish_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: PROCESS_MASTER,
        label: "Process",
        isActiveUri: [PROCESS_MASTER_ADD, PROCESS_MASTER_EDIT],
        permission: "process_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/series",
        label: "Series",
        isActiveUri: ["/master/series/add", "/master/series/edit"],
        permission: "series_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/size",
        label: "Size",
        isActiveUri: ["/master/size/add", "/master/size/edit"],
        permission: "size_master",
        type: "nav-item",
        icon: <MonetizationOnIcon sx={{ fontSize: 20 }} />,
      },

      {
        uri: "/master/supplier",
        label: "sidebar.menuItem.master.supplier",
        isActiveUri: [
          "/master/supplier/add",
          "/master/category/edit",
          "/master/supplier/branch/add/:id",
          "/master/supplier/branch/list/:id",
          "/master/supplier/edit/:id",
          "/master/supplier/contact-person-list",
        ],
        permission: "supplier_master",
        type: "nav-item",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: TRANSPORTER_MASTER,
        label: "Transporter",
        isActiveUri: [TRANSPORTER_MASTER_ADD, TRANSPORTER_MASTER_EDIT],
        permission: "transporter_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/unit",
        label: "Unit",
        isActiveUri: ["/master/unit/add", "/master/unit/edit"],
        permission: "unit_master",
        type: "nav-item",
        icon: <MonetizationOnIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: VEHICLE_MASTER,
        label: "Vehicle",
        isActiveUri: [VEHICLE_MASTER_ADD, VEHICLE_MASTER_EDIT],
        permission: "vehicle_master",
        type: "nav-item",
        icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      },

    ],
  },
  {
    label: "Expenses Master",
    type: "collapsible",
    icon: <PaidIcon sx={{ fontSize: 20 }} />,
    children: [
      {
        uri: "/master/expense/log",
        label: "Log",
        isActiveUri: ["/master/expense/log/add/:invoiceId"],
        type: "nav-item",
        permission: "expense_master",
      },
      {
        uri: "/master/expense/flitch",
        label: "Flitch",
        isActiveUri: ["/master/expense/flitch/add/:invoiceId"],
        type: "nav-item",
        permission: "expense_master",
      },
      {
        uri: "/master/expense/plywood",
        label: "Plywood",
        isActiveUri: ["/master/expense/plywood/add/:invoiceId"],
        type: "nav-item",
        permission: "expense_master",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/expense/veneer",
        label: "Veneer",
        isActiveUri: ["/master/expense/veneer/add/:invoiceId"],
        type: "nav-item",
        permission: "expense_master",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/expense/mdf",
        label: "MDF",
        isActiveUri: ["/master/expense/mdf/add/:invoiceId"],
        type: "nav-item",
        permission: "expense_master",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/expense/face",
        label: "Face",
        isActiveUri: ["/master/expense/face/add/:invoiceId"],
        type: "nav-item",
        permission: "expense_master",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/expense/core",
        label: "Core",
        isActiveUri: ["/master/expense/core/add/:invoiceId"],
        type: "nav-item",
        permission: "expense_master",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/expense/fleece",
        label: "Fleece Paper",
        isActiveUri: ["/master/expense/fleece/add/:invoiceId"],
        type: "nav-item",
        permission: "expense_master",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/master/expense/other-goods",
        label: "Other Goods",
        isActiveUri: ["/master/expense/other-goods/add/:invoiceId"],
        type: "nav-item",
        permission: "expense_master",
        icon: <ScaleIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.inventory",
    type: "collapsible",
    icon: <InventoryIcon sx={{ fontSize: 20 }} />,
    children: [
      {
        uri: "/inventory/log",
        label: "Log",
        isActiveUri: [
          "/inventory/log/add",
          "/inventory/log/edit",
          "/inventory/log-approval/view-details/:id/:invoiceId",
          LOG_INVENTORY_ISSUE_ORDER,
        ],
        type: "nav-item",
        permission: "log_inventory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/inventory/flitch",
        label: "Flitch",
        isActiveUri: [
          "/inventory/flitch/add",
          "/inventory/flitch/edit",
          "/inventory/flitch-approval/view-details/:id/:invoiceId",
          FLITCH_INVENTORY_ISSUE_ORDER,
        ],
        type: "nav-item",
        permission: "flitch_inventory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/inventory/plywood",
        label: "Plywood",
        isActiveUri: [
          "/inventory/plywood/add",
          "/inventory/plywood/edit",
          "/inventory/plywood-approval/view-details/:id/:invoiceId",
          PLYWOOD_RAW_ORDER,
        ],
        type: "nav-item",
        permission: "plywood_inventory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/inventory/veneer",
        label: "Veneer",
        isActiveUri: [
          "/inventory/veneer/add",
          "/inventory/veneer/edit",
          "/inventory/veneer-approval/view-details/:id/:invoiceId",
          VENEER_INVENTORY_ISSUE_ORDER,
        ],
        type: "nav-item",
        permission: "veneer_inventory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/inventory/mdf",
        label: "MDF",
        isActiveUri: [
          "/inventory/mdf/add",
          "/inventory/mdf/edit",
          "/inventory/mdf-approval/view-details/:id/:invoiceId",
          MDF_RAW_ORDER,
        ],
        type: "nav-item",
        permission: "mdf_inventory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/inventory/face",
        label: "Face",
        isActiveUri: [
          "/inventory/face/add",
          "/inventory/face/edit",
          "/inventory/face-approval/view-details/:id/:invoiceId",
          FACE_RAW_ORDER,
        ],
        type: "nav-item",
        permission: "face_inventory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/inventory/core",
        label: "Core",
        isActiveUri: [
          "/inventory/core/add",
          "/inventory/core/edit",
          "/inventory/core-approval/view-details/:id/:invoiceId",
          CORE_RAW_ORDER,
        ],
        type: "nav-item",
        permission: "core_inventory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/inventory/fleece",
        label: "Fleece Paper",
        isActiveUri: [
          "/inventory/fleece/add",
          "/inventory/fleece/edit",
          "/inventory/fleece-approval/view-details/:id/:invoiceId",
          FLEECE_RAW_ORDER,
        ],
        type: "nav-item",
        permission: "fleece_paper_inventory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/inventory/other-goods",
        label: "Other Goods",
        isActiveUri: [
          "/inventory/other-goods/add",
          "/inventory/other-goods/edit",
          "/inventory/otherGoods-approval/view-details/:id/:invoiceId",
          OTHER_GOODS_RAW_ORDER,
        ],
        type: "nav-item",
        permission: "other_goods_inventory",
        icon: <ScaleIcon sx={{ fontSize: 20 }} />,
      },
      // {
      //   uri: "inventory/groupedveneer",
      //   label: "sidebar.menuItem.inventory.groupedVeneer",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"grouped_veneer_view",
      //   icon: <MonetizationOnIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "inventory/readysheetform",
      //   label: "sidebar.menuItem.inventory.readySheetForm",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"ready_sheet_form_view",
      //   icon: <DescriptionOutlinedIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "inventory/readyForDispatch",
      //   label: "sidebar.menuItem.inventory.readyForDispatch",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"qc_view",
      //   icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      // },
    ],
  },
  {
    label: "sidebar.menu.factory",
    type: "collapsible",
    icon: <FactoryIcon sx={{ fontSize: 20 }} />,
    children: [
      {
        uri: "/factory/crosscut",
        label: "Crosscut",
        isActiveUri: [
          "/factory/add-crosscut",
          "/factory/edit-crosscut",
          "/factory/crosscut-approval/view-details/:id/:issued_for_cutting_id",
          CROSSCUT_FACTORY_ISSUE_ORDER,
        ],
        type: "nav-item",
        permission: "crosscut_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/factory/flitching",
        label: "Flitching",
        isActiveUri: [
          "/factory/add-flitching",
          "/factory/edit-flitching",
          "/factory/flitching-approval/view-details/:id/:issue_for_flitching_id",
          FLITCHING_FACTORY_ISSUE_ORDER,
        ],
        type: "nav-item",
        permission: "flitching_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: FACTORY_SLICING,
        label: "Slicing",
        isActiveUri: [
          FACTORY_SLICING,
          FACTORY_RE_SLICING_ADD,
          FACTORY_SLICING_ADD,
          FACTORY_SLICING_EDIT,
        ],
        type: "nav-item",
        permission: "slicing_factory",
      },
      {
        uri: "/factory/peeling",
        label: "Peeling",
        isActiveUri: [
          PEELING_FACTORY,
          PEELING_FACTORY_ADD,
          PEELING_FACTORY_EDIT,
        ],
        type: "nav-item",
        permission: "peeling_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      // {
      //   uri: FACTORY_GROUPING,
      //   label: "Grouping",
      //   isActiveUri: [
      //     FACTORY_GROUPING,
      //     FACTORY_GROUPING_ADD,
      //     FACTORY_GROUPING_EDIT,
      //     FACTORY_REGROUPING_ADD,
      //   ],
      //   type: "nav-item",
      //   permission: "grouping_factory",
      // },
      {
        uri: FACTORY_DRESSING,
        label: "Dressing",
        isActiveUri: [
          FACTORY_DRESSING,
          FACTORY_RE_DRESSING_ADD,
          FACTORY_DRESSING_ADD,
          FACTORY_DRESSING_EDIT,
          DRESSING_FACTORY_ISSUE_ORDER,
        ],
        type: "nav-item",
        permission: "dressing_factory",
      },
      {
        uri: FACTORY_SMOKING_DYING,
        label: "Smoking & Dying",
        isActiveUri: [
          FACTORY_SMOKING_DYING,
          FACTORY_SMOKING_DYING_ADD,
          FACTORY_SMOKING_DYING_EDIT,
        ],
        type: "nav-item",
        permission: "smoking_dying_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: FACTORY_GROUPING,
        label: "Grouping",
        isActiveUri: [
          FACTORY_GROUPING,
          FACTORY_GROUPING_ADD,
          FACTORY_GROUPING_EDIT,
          FACTORY_REGROUPING_ADD,
          GROUPING_FACTORY_ISSUE_ORDER,
        ],
        type: "nav-item",
        permission: "grouping_factory",
      },
      {
        uri: FACTORY_TAPPING,
        label: "Tapping",
        isActiveUri: [
          FACTORY_TAPPING,
          FACTORY_TAPPING_ADD,
          FACTORY_TAPPING_EDIT,
        ],
        type: "nav-item",
        permission: "tapping_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      // {
      //   uri: FACTORY_POLISHING,
      //   label: "Polishing",
      //   isActiveUri: [FACTORY_POLISHING],
      //   type: "nav-item",
      //   permission: "polishing_factory",
      //   icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: FACTORY_ACCO,
      //   label: "ACCO",
      //   isActiveUri: [FACTORY_ACCO],
      //   type: "nav-item",
      //   permission: "acco_factory",
      //   icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: FACTORY_PLYWOOD_PRODUCTION,
      //   label: "Plywood Production",
      //   isActiveUri: [FACTORY_PLYWOOD_PRODUCTION],
      //   type: "nav-item",
      //   permission: "plywood_production_factory",
      //   icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      // },
      {
        uri: FACTORY_RE_SIZING_PLYWOOD,
        label: "Re-Sizing Plywood",
        isActiveUri: [
          FACTORY_RE_SIZING_PLYWOOD,
          FACTORY_RE_SIZING_PLYWOOD_ADD,
          FACTORY_RE_SIZING_PLYWOOD_EDIT,
        ],
        type: "nav-item",
        permission: "re_sizing_plywood_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: FACTORY_PLYWOOD_PRODUCTION,
        label: "Plywood Production",
        isActiveUri: [
          FACTORY_PLYWOOD_PRODUCTION,
          FACTORY_CREATE_PLYWOOD_PRODUCTION,
          FACTORY_EDIT_PLYWOOD_PRODUCTION,
        ],
        type: "nav-item",
        permission: "plywood_production_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: FACTORY_PRESSING,
        label: "Pressing",
        isActiveUri: [FACTORY_PRESSING, FACTORY_PRESSING_ADD],
        type: "nav-item",
        permission: "pressing_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: FACTORY_CNC,
        label: "CNC",
        isActiveUri: [FACTORY_CNC, FACTORY_CNC_ADD],
        type: "nav-item",
        permission: "cnc_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: FACTORY_COLOUR,
        label: "Color",
        isActiveUri: [FACTORY_COLOUR, FACTORY_COLOUR_ADD],
        type: "nav-item",
        permission: "colour_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: FACTORY_BUNITO,
        label: "Bunito",
        isActiveUri: [FACTORY_BUNITO, FACTORY_BUNITO_ADD],
        type: "nav-item",
        permission: "bunito_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: FACTORY_CANVAS,
        label: "Canvas",
        isActiveUri: [FACTORY_CANVAS, FACTORY_CANVAS_ADD],
        type: "nav-item",
        permission: "canvas_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: FACTORY_POLISHING,
        label: "Polishing",
        isActiveUri: [FACTORY_POLISHING, FACTORY_POLISHING_ADD],
        type: "nav-item",
        permission: "polishing_factory",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      // {
      //   uri: "grouping",
      //   label: "sidebar.menuItem.factory.grouping",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"grouping_view",
      //   icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "factory/smoking",
      //   label: "sidebar.menuItem.factory.smoking",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"smoking_view",
      //   icon: <ScaleIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "factory/dying",
      //   label: "sidebar.menuItem.factory.dying",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"dying_view",
      //   icon: <MonetizationOnIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "factory/cutting",
      //   label: "sidebar.menuItem.factory.cutting",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"cutting_view",
      //   icon: <DescriptionOutlinedIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "factory/tapping",
      //   label: "sidebar.menuItem.factory.tapping",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"tapping_view",
      //   icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "factory/pressing",
      //   label: "sidebar.menuItem.factory.pressing",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"pressing_view",
      //   icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "factory/finishing",
      //   label: "sidebar.menuItem.factory.finishing",
      //   isActiveUri: [],
      //   type: "nav-item",
      //   permission:"finishing_view",
      //   icon: <LocalOfferOutlinedIcon sx={{ fontSize: 20 }} />,
      // },
    ],
  },
  // {
  //   uri: PACKING_ROUTE,
  //   label: "Packing",
  //   isActiveUri: [PACKING_ROUTE],
  //   type: "nav-item",
  //   permission: "packing_permission",
  //   icon: <PentagonIcon sx={{ fontSize: 22 }} />,
  // },
  {
    label: "sidebar.menu.seriesProduct",
    type: "collapsible",
    icon: <StarIcon sx={{ fontSize: 20 }} />,
    children: [
      {
        uri: BARCODE,
        label: "Barcode",
        isActiveUri: [BARCODE, BARCODE_ADD, BARCODE_EDIT],
        type: "nav-item",
        permission: "barcode_series_product",
      },
      {
        uri: CHROMA_COLLECTION,
        label: "Chroma Collection",
        isActiveUri: [
          CHROMA_COLLECTION,
          CHROMA_COLLECTION_ADD,
          CHROMA_COLLECTION_EDIT,
        ],
        type: "nav-item",
        permission: "chroma_collection_series_product",
      },
      {
        uri: CHROMA_COMPOSITE,
        label: "Chroma Composite",
        isActiveUri: [
          CHROMA_COMPOSITE,
          CHROMA_COMPOSITE_ADD,
          CHROMA_COMPOSITE_EDIT,
        ],
        type: "nav-item",
        permission: "chroma_composite_series_product",
      },
      {
        uri: CHROMA_RIBBED,
        label: "Chroma Ribbed",
        isActiveUri: [CHROMA_RIBBED, CHROMA_RIBBED_ADD, CHROMA_RIBBED_EDIT],
        type: "nav-item",
        permission: "chroma_ribbed_series_product",
      },
      {
        uri: BUNITO,
        label: "Bunito",
        isActiveUri: [BUNITO, BUNITO_ADD, BUNITO_EDIT],
        type: "nav-item",
        permission: "bunito_series_product",
      },
      {
        uri: MATTLE,
        label: "Mattle",
        isActiveUri: [MATTLE, MATTLE_ADD, MATTLE_EDIT],
        type: "nav-item",
        permission: "mattle_series_product",
      },
      {
        uri: CANVAS,
        label: "Canvas",
        isActiveUri: [CANVAS, CANVAS_ADD, CANVAS_EDIT],
        type: "nav-item",
        permission: "canvas_series_product",
      },
      {
        uri: NOVEL,
        label: "Novel",
        isActiveUri: [NOVEL, NOVEL_ADD, NOVEL_EDIT],
        type: "nav-item",
        permission: "novel_series_product",
      },
      {
        uri: MARVEL,
        label: "Marvel",
        isActiveUri: [MARVEL, MARVEL_ADD, MARVEL_EDIT],
        type: "nav-item",
        permission: "marvel_series_product",
      },
      {
        uri: REGANTO_DEZINER,
        label: "Reganto Deziner",
        isActiveUri: [
          REGANTO_DEZINER,
          REGANTO_DEZINER_ADD,
          REGANTO_DEZINER_EDIT,
        ],
        type: "nav-item",
        permission: "reganto_deziner_series_product",
      },
      {
        uri: REGANTO_CLASSIC,
        label: "Reganto Classic",
        isActiveUri: [
          REGANTO_CLASSIC,
          REGANTO_CLASSIC_ADD,
          REGANTO_CLASSIC_EDIT,
        ],
        type: "nav-item",
        permission: "reganto_classic_series_product",
      },
      {
        uri: REGANTO_PREMIER,
        label: "Reganto Premier",
        isActiveUri: [
          REGANTO_PREMIER,
          REGANTO_PREMIER_ADD,
          REGANTO_PREMIER_EDIT,
        ],
        type: "nav-item",
        permission: "reganto_premier_series_product",
      },
      {
        uri: FURROW,
        label: "Furrow",
        isActiveUri: [FURROW, FURROW_ADD, FURROW_EDIT],
        type: "nav-item",
        permission: "furrow_series_product",
      },
      {
        uri: FURROW_LITE,
        label: "Furrow Lite",
        isActiveUri: [FURROW_LITE, FURROW_LITE_ADD, FURROW_LITE_EDIT],
        type: "nav-item",
        permission: "furrow_lite_series_product",
      },
      {
        uri: FURROW_REGANTO,
        label: "Furrow Reganto",
        isActiveUri: [FURROW_REGANTO, FURROW_REGANTO_ADD, FURROW_REGANTO_EDIT],
        type: "nav-item",
        permission: "furrow_reganto_series_product",
      },
      {
        uri: ACCO,
        label: "ACCO",
        isActiveUri: [ACCO, ACCO_ADD, ACCO_EDIT],
        type: "nav-item",
        permission: "acco_series_product",
      },
    ],
  },
  {
    uri: ORDER_ROUTE,
    label: "Order",
    isActiveUri: [
      ORDER_ROUTE,
      CREATE_RAW_ORDER,
      CREATE_DECORATIVE_ORDER,
      EDIT_DECORATIVE_ORDER,
    ],
    type: "nav-item",
    permission: "order_permission",
    icon: <ListAltIcon sx={{ fontSize: 22 }} />,
  },
  // {
  //   uri: DISPATCH_ROUTE,
  //   label: "Dispatch",
  //   isActiveUri: [DISPATCH_ROUTE],
  //   type: "nav-item",
  //   permission: "dispatch_permission",
  //   icon: <LocalShippingIcon sx={{ fontSize: 22 }} />,
  // },
  {
    uri: CHALLAN_ROUTE,
    label: "Challan",
    isActiveUri: [
      CHALLAN_ROUTE,
      CHALLAN_ADD_ROUTE,
      CHALLAN_VIEW_ROUTE,
      CHALLAN_EDIT_ROUTE,
    ],
    type: "nav-item",
    permission: "challan_permission",
    icon: <ReceiptLongIcon sx={{ fontSize: 22 }} />,
  },
  {
    uri: PACKING_ROUTE,
    label: "Packing",
    isActiveUri: [
      PACKING_ROUTE,
      PACKING_ADD_ROUTE_RAW,
      PACKING_ADD_ROUTE_FINISHED,
      PACKING_VIEW_ROUTE,
      PACKING_EDIT_RAW_ROUTE,
      PACKING_EDIT_FINISHED_ROUTE,
      PACKING_APPROVAL_VIEW_DETAILS_ROUTE
    ],
    type: "nav-item",
    permission: "packing_permission",
    icon: <MoveToInbox sx={{ fontSize: 22 }} />,
  },
  {
    uri: DISPATCH_ROUTE,
    label: "Dispatch",
    isActiveUri: [
      DISPATCH_ROUTE,
      DISPATCH_ADD_ROUTE,
      DISPATCH_APPROVAL_ROUTE,
      DISPATCH_VIEW_ROUTE,
      DISPATCH_APPROVAL_VIEW_ROUTE,

      DISPATCH_EDIT_ROUTE,
    ],
    type: "nav-item",
    permission: "dispatch_permission",
    icon: <LocalShippingIcon sx={{ fontSize: 22 }} />,
  },
  // {
  //   label: "sidebar.menu.factory",
  //   type: "section",
  //   children: [
  //   ],
  // },
  // {
  //   uri: "orders",
  //   label: "sidebar.menuItem.orders",
  //   type: "nav-item",
  //   permission: "orders_view",
  //   icon: <AssignmentOutlinedIcon sx={{ fontSize: 20 }} />,
  // },
  // {
  //   uri: "dispatch",
  //   label: "sidebar.menuItem.dispatch",
  //   type: "nav-item",
  //   permission: "dispatch_view",
  //   icon: <LocalShippingOutlinedIcon sx={{ fontSize: 20 }} />,
  // },
  // {
  //   label: "sidebar.menu.orders&dispatch",
  //   type: "section",
  //   children: [
  //   ],
  // },
];

export default menus;
